import { JackpotLevel } from "./api";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplay1screen } from "./JackpotDisplay1Screen";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotText } from "./JackpotText";
import { JackPotTextParams } from "./JackPotTextParams";
import { MoneyFormatter } from "./MoneyFormatter";
import { Size, LogGroup, Scale } from "./MyHelpers";
import { FontResource } from "./ResourceManager/FontResource";
import { ImageResource } from "./ResourceManager/ImageResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import { ScreenProtocolScope, ScreenProtocol } from "./ScreenProtocol";
import { Settings } from "./Settings";
import { PickBonusMessages } from "./slot/PickBonus/PickMessage";
//import { JackpotValue } from "./slot/SlotGame";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";

export class JackpotDisplayJubileeLink1Screen extends JackpotDisplay1screen {

	public constructor(param: JackpotDisplayParams) {
		super(param)
		this.systemContext = param.systemContext.CreateSubContext("JackpotDisplayOrtiz");

		this.resid = param.resid.Add("JackpotDisplayOrtiz");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayOrtiz");

		this.screenProtocol = param.screenProtocol;
		//this.logGroup.SetSpecificName(this.name);
		//Ruta de background de los niveles jackpot
		this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/";


	}


	protected override LoadFrames(resourceManager: ResourceManager): void {
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayJubileeLink/FrameJackpot_1Screen/RubyJackpot_1Screen.png", this.resid.ScopedResourceName(["jp3", "image"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayJubileeLink/FrameJackpot_1Screen/diamond_frame_jackpots.png", this.resid.ScopedResourceName(["jp4", "image"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayJubileeLink/FrameJackpot_1Screen/emmerald_frame_jackpots.png", this.resid.ScopedResourceName(["jp2", "image"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayJubileeLink/FrameJackpot_1Screen/sapphire_frame_jackpots.png", this.resid.ScopedResourceName(["jp1", "image"])));
		//resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/DRAGON-JACKPOT-NAME.png", this.resid.ScopedResourceName(["DragonJackpotName"])));		
		resourceManager.Add(new FontResource(this.jackpot + "fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));
	}

	// public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
	// 	await super.ResourcesLoaded(resourceManager);		
	// }

	protected override createContainerJp(resourceManager : ResourceManager){
		super.createContainerJp(resourceManager);
		//container JP4
		this.ContainerJP4.style.right = Scale.Xpx(-121);
		this.ContainerJP4.style.top = Scale.Xpx(10);
		//background jp4		
		this.BackgroundJp4.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp3", "image"])).CssBackground();
		this.BackgroundJp4.style.height = Scale.Hpx(187);
		
		//container JP3
		this.ContainerJp3.style.right = Scale.Xpx(-29);
		this.ContainerJp3.style.width = Scale.Xpx(486);
		this.ContainerJp3.style.height = Scale.Xpx(135);		
		//background jp3
		this.BackgroundJp3.style.width = "100%";
		this.BackgroundJp3.style.height = "100%";
		
		//container jp2		
		this.ContainerJp2.style.width = Scale.Wpx(490);
		this.ContainerJp2.style.height = Scale.Hpx(130);
		this.ContainerJp2.style.right = Scale.Xpx(-53);
		//background jp2
		this.BackgroundJp2.style.height ="100%";
		this.BackgroundJp2.style.width = "100%";
		
		//container jp1		
		this.ContainerJp1.style.width = Scale.Wpx(440);
		this.ContainerJp1.style.height = Scale.Hpx(130);
		this.ContainerJp1.style.right = Scale.Xpx(-39);
		//background jp1
		this.BackgroundJp1.style.height = "100%";
		this.BackgroundJp1.style.width = "100%";
		this.BackgroundJp3.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp4", "image"])).CssBackground();
	}

	protected override async createJPText(resourceManager: ResourceManager){	
		
		let jp4TextParams: JackPotTextParams={
			logGroup: this.logGroup.Add("White"),
			width: Scale.W(505),//908
			height: Scale.H(85),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
			//fontHeight : Scale.fh(300)
		}

		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(315);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.bottom = Scale.Ypx(41);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.ContainerJP4.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());

		

		let jp3TextParams: JackPotTextParams={
			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(298),
			height: Scale.H(55),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(136);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.bottom = Scale.Ypx(33);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		this.BackgroundJp3.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());

		let jp2TextParams: JackPotTextParams={
			logGroup: this.logGroup.Add("Green"),
			width: Scale.W(267),
			height: Scale.H(45),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(150);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.bottom = Scale.Ypx(33);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		this.BackgroundJp2.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());

		let jp1TextParams: JackPotTextParams={
			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(253),
			height: Scale.H(42),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(133);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.bottom = Scale.Ypx(28);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";
		this.BackgroundJp1.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());
	}
	protected override createTitleJpContainer (resourceManager : ResourceManager){
		//dosent need add title , frame contain name 
	}
}
